export function getStatsByCategoryIdsAndPlayingAs(categoryIds, stats, filterPlayingAs, isHomeTeam, statIndexes) {
  // console.log('LLEgo aqui a lal fucion final');
  // console.log(categoryIds);
  // console.log(stats);
  // console.log(filterPlayingAs);
  // console.log(isHomeTeam);
  // console.log(statIndexes);
  // console.log('************************************************');
  const teamPlayingAs = filterPlayingAs === 2 ? [1, 2] : [isHomeTeam ? 1 : 2];
  // console.log('teamPlayingAs');
  // console.log(teamPlayingAs);
  // console.log('************************************************');
  var numdeestadisticas = stats.filter(stat => {
    return categoryIds.includes(stat[statIndexes.categoryId]) && teamPlayingAs.includes(stat[statIndexes.playingAs]);
  });
  // console.log(numdeestadisticas);
  // console.log('************************************************');
  return numdeestadisticas;
}
